// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "" + {"48":"route-team","426":"route-unstoppable","490":"route-staking","530":"route-quests","572":"route-clay","643":"route-vesting","757":"route-become-a-citizen","918":"route-partners","942":"route-home"}[chunkId] + "." + __webpack_require__.h() + ".css";
};